import type { AnalyticsOverview } from "@/types";

import { BaseApi } from "./base.api";

export interface AnalyticsRange {
  /** "2026-08-01". Berilmasa oxirgi 30 kun. */
  from?: string;
  to?: string;
}

/**
 * O'z analitikamiz.
 *
 * Yandex Metrika ma'lumoti bu yerda YO'Q: u o'z panelida qoladi va uni
 * bizning jadvallarimiz bilan bog'lab bo'lmaydi. Bu endpoint esa
 * `events` jadvalidan o'qiydi — ya'ni "qaysi sahifa ochilgan va o'sha
 * odam keyin nima qilgan" degan savolga javob beradi.
 */
class AnalyticsApi extends BaseApi {
  overview(range: AnalyticsRange = {}) {
    return this.request<AnalyticsOverview>("/analytics/overview", { query: { ...range } });
  }
}

export const analyticsApi = new AnalyticsApi();
